import React, { memo, useEffect, useMemo, useState } from 'react'
import { Select } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { userSelector } from '../../store/session'
import { projectSelector, getProjectsAction } from '../../store/projects'

const ProjectSelector = ({ value, onChange, mode = null, userFilter = true, ...rest }) => {
  const dispatch = useDispatch()
  const { user } = useSelector(userSelector)

  const { projects } = useSelector(projectSelector)

  const [projectsData, setProjectsData] = useState([])

  useEffect(() => {
    if (userFilter) {
      setProjectsData(
        user?.projects?.map((item) => ({
          value: item.id,
          label: item.name,
        }))
      )
    } else if (projects && projects.length > 0) {
      setProjectsData(projects?.map((item) => ({ value: item.id, label: item.attributes.name })))
    } else {
      dispatch(getProjectsAction({ pagination: {} }))
    }
  }, [user, projects])

  return (
    <Select
      value={value}
      onChange={onChange}
      options={projectsData}
      mode={mode}
      allowClear
      dropdownMatchSelectWidth={false}
      {...rest}
    />
  )
}

export default memo(ProjectSelector)
